import React, { useEffect} from "react";
import { connect } from "react-redux";
import { Table } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { getEmployeeList, doEmployeeDelete } from "../../../../redux/employee/employeeState";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import { handleTableChange } from "../../../../utils/index";
import avatar from "assets/img/avatars/user.png";
import Badge from "components/badge";
import EmployeeProfile from "components/card/EmployeeProfile";
import EmployeeInfoForm from "./EmployeeInfoForm";
import PopupButton from "components/button/PopupButton";
import { EMPLOYMENT_STATUS_COLORS, COUNTRY_FLAG_ICONS } from "variables/constants";


const EmployeeTable = ({ 
	recordList, 
	pagination, 
	doSearch, 
	doDelete, 
	filters, 
	countryList,
	clientList
}) => {
	const { getColumnSearchProps } = ColumnSearchFilter();

  	const columns = [
		{
	        title: `Employee`,
	        dataIndex: 'emp_code',
	        key: 'emp_code',
	        width: '25%',
	        sorter: true,
	        render:(_, record) => (
				<EmployeeProfile
					avatar={avatar}
					record={record}
				/>
			),
	       
	    },
		{
			title: 'Country',
			key: 'country',
			width: '12%',
			sorter: true,
			filters: countryList
				?.filter((country) => country.value !== 'all')
				.map((country) => ({
				text: country.label,
				value: country.value
			})) || [],
			render: (_, record) => {
				const country = record?.user_detail?.address?.country;

				return (
				<div className="flex items-center gap-2">
					{COUNTRY_FLAG_ICONS?.[country?.cou_code] ?? null}
					<span>{country?.cou_name || '-'}</span>
				</div>
				);
			}
		},
		{
			title: (
				<>
					<div>Job Position /</div>
					<div>Hire Date</div>
				</>
			),
			key: 'job_info',
			width: '15%',  
			sorter: true,
			...getColumnSearchProps(['emp_title', 'emp_hire_date']),
			render:(_, record) => (
				<>
					<div>{`${record.emp_title ? record.emp_title : '_'}`}</div>
					<div>{`${record.emp_hire_date ? record.emp_hire_date : '_'}`}</div>
				</>
			)
	    },

		{
	        title: `Client`,
	        dataIndex: 'emp_client_id',
	        key: 'emp_client_id',
	        width: '15%',  
	        sorter: true,
			filters: clientList?.map((client) => ({
				text: client.label,
				value: client.value
			})) || [],
	        render:(_, record) => (
				<span>{`${record?.client_name}`}</span>
			),
	    },

	    {
	        title: `Status`,
	        dataIndex: 'employment_status_name',
	        key: 'employment_status_name',
	        width: '14%',
			...getColumnSearchProps('employment_status_name'),
	        render: (employment_status_name) => (
				<Badge color={EMPLOYMENT_STATUS_COLORS[employment_status_name]}>
					<span>{employment_status_name}</span>
				</Badge>
			)
	    },
	    {
	        title: 	<PopupButton id="add_employee" title="Add Employee" label="Add" btnClass="btn-small" >
						<EmployeeInfoForm recordId="0" mode="edit"/>
					</PopupButton>,
	        dataIndex: 'emp_id',
	        key: 'emp_id',
	        width: '14%',
	        render:(emp_id) => <CrudOption baseRoute="/console/employees" recordId={emp_id} deleteHandler={doDelete} allowEdit={false}/>
	    },
    ];
	
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"}>
			<div className="py-2 mb-2">
				<SearchFilter 
					placeholder="Search by Employee Id or Name" 
					searchHandler={doSearch} 
					filters={filters} 
					pagination={pagination}
				/>
			</div>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.emp_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
		            onChange={handleTableChange(doSearch, filters)}  
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.employee.employeeList?.items,
	pagination: state.employee.employeeList?.pagination,
	filters: state.employee.employeeList?.filters,
  	requesting: state.employee.employeeList?.requesting,
  	error: state.employee.employeeList?.error,
	countryList: state.optionlist.countryList?.items,
	clientList: state.optionlist.clientList?.items,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeList(filters)),
  doDelete: (id) => dispatch(doEmployeeDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTable);